import { FormlyDropdownValue, MeterCollar } from '@intellio/shared/models';

type MeterCollarOptionSelector = (meterCollar: MeterCollar) => string;

const mapUniqueMeterCollarOptions = (
  meterCollars: MeterCollar[],
  selector: MeterCollarOptionSelector
): FormlyDropdownValue[] => {
  return meterCollars.reduce<FormlyDropdownValue[]>((options, meterCollar) => {
    const value = selector(meterCollar);

    if (!value || options.some((option) => option.value === value)) {
      return options;
    }

    return options.concat({
      value,
      label: value,
    });
  }, []);
};

const formatMeterCollarMetadata = (meterCollar: MeterCollar): string[] => {
  return [
    meterCollar.serviceAmpRating,
    meterCollar.circuitBreakerAmps,
    meterCollar.useCase,
    meterCollar.meterForm,
  ].map((value) => (value === null || value === undefined ? '' : `${value}`));
};

export const mapMeterCollarMakeOptions = (
  meterCollars: MeterCollar[]
): FormlyDropdownValue[] => {
  return mapUniqueMeterCollarOptions(
    meterCollars,
    (meterCollar) => meterCollar.make
  );
};

export const mapMeterCollarModelOptions = (
  meterCollars: MeterCollar[],
  make?: string
): FormlyDropdownValue[] => {
  return (make
    ? meterCollars.filter((meterCollar) => meterCollar.make === make)
    : meterCollars
  )
    .filter((meterCollar) => meterCollar.model)
    .map((meterCollar) => {
      const metadata = formatMeterCollarMetadata(meterCollar);

      return {
        value: meterCollar.model,
        label: [meterCollar.model, ...metadata].join(' | '),
        displayLabel: meterCollar.model,
        displayMetadata: metadata,
      };
    });
};
